<template>
  <div>
    <!-- Header -->
    <div class="header bg-gradient-dark py-7 py-lg-8 pt-lg-9">
      <b-container class="container">
        <div class="header-body text-center mb-4">
          <b-row class="justify-content-center">
            <b-col class="px-5">
              <h1 class="text-white">Inscrição - Profissional</h1>
              <p class="text-lead text-white">
                Para mais informações, acesse o regulamento de Profissional:
                <a
                  href="/regulamentos/regulamento-premio-profissionais-2021.pdf"
                  class="text-white text-lead"
                  target="_blank"
                >
                  <b-button size="sm" class="font-weight-bold ml-2">
                    Regulamento
                  </b-button>
                </a>
              </p>
            </b-col>
          </b-row>
        </div>
      </b-container>
      <div class="separator separator-bottom separator-skew zindex-100">
        <svg
          x="0"
          y="0"
          viewBox="0 0 2560 100"
          preserveAspectRatio="none"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <polygon class="fill-darker" points="2560 0 2560 100 0 100"></polygon>
        </svg>
      </div>
    </div>
    <!-- Page content -->
    <profissional-form :userForm="true" />
  </div>
</template>
<script>
import ProfissionalForm from "@/components/Forms/ProfissionalForm.vue";

export default {
  components: {
    ProfissionalForm,
  },
};
</script>
<style></style>
